<template>
  <div
    :class="[
      'container',
      {
        'fix-height':
          modalView === SeasonModalView.burnTokens ||
          modalView === SeasonModalView.leaderboard ||
          modalView === SeasonModalView.jackpot
      }
    ]"
  >
    <div class="top-gradient-overlay" />
    <img alt="" class="infoIcon" src="/img/icons/ic_info.svg" width="24" @click="showInfoPopup = true" />
    <el-dialog
      v-model="showInfoPopup"
      :class="{ 'ru-locale': $i18n.locale === 'ru' }"
      :fullscreen="$device.isMobile"
      :title="$t(modalView === SeasonModalView.jackpot ? 'seasonWhatIsJackpot' : 'seasonWhatIsSeason')"
      class="tripleBlockInfo"
      modal-class="modalSeasonInfo"
      width="100%"
    >
      <GeneralInfoModal
        v-if="modalView === SeasonModalView.jackpot"
        :config="infoModalJackpot"
        :description="$t('seasonInfoModalDescriptionJackpot')"
        @close="showInfoPopup = false"
      />

      <GeneralInfoModal
        v-else
        :config="infoModal"
        :description="$t('seasonInfoModalDescriptionJackpot')"
        @close="showInfoPopup = false"
      />
    </el-dialog>
    <p
      v-if="
        modalView !== SeasonModalView.end &&
        modalView !== SeasonModalView.rewards &&
        modalView !== SeasonModalView.jackpot &&
        modalView !== SeasonModalView.endedInfo
      "
      class="seasonDuration"
    >
      {{ $t('seasonEndsIn') }}:
      <ClientOnly>
        <span>
          {{
            BigNumber(timeLeft?.days ?? 0).isGreaterThan(0)
              ? `${Formatters.text.zeroPrefix(timeLeft?.days ?? 0)}${t('coreDaysPostfix')}`
              : ''
          }}
          {{
            BigNumber(timeLeft?.hours ?? 0).isGreaterThan(0)
              ? `${Formatters.text.zeroPrefix(timeLeft?.hours ?? 0)}${t('coreHoursPostfix')}`
              : ''
          }}
          {{
            BigNumber(timeLeft?.minutes ?? 0).isGreaterThan(0)
              ? `${Formatters.text.zeroPrefix(timeLeft?.minutes ?? 0)}${t('coreMinPostfix')}`
              : ''
          }}
          {{
            BigNumber(timeLeft?.hours ?? 0).isZero() && BigNumber(timeLeft?.seconds ?? 0).isGreaterThan(0)
              ? `${Formatters.text.zeroPrefix(timeLeft?.seconds ?? 0)}${t('coreSecPostfix')}`
              : ''
          }}
        </span>
      </ClientOnly>
    </p>
    <p v-if="modalView === SeasonModalView.endedInfo" class="seasonDuration">
      {{ prevSeasonStartDate }} - {{ prevSeasonEndDate }}
    </p>
    <p
      v-if="
        SEASON_MODAL_VIEW_CONFIG[modalView].descriptionKey &&
        !(modalView === SeasonModalView.jackpot && $device.isMobile)
      "
      class="seasonDescription"
    >
      {{ $t('seasonModalDescription37') }}
    </p>

    <SeasonModalSwitcher
      v-if="
        modalView !== SeasonModalView.end &&
        modalView !== SeasonModalView.rewards &&
        modalView !== SeasonModalView.start &&
        modalView !== SeasonModalView.endedInfo
      "
      :modal-view="modalView"
      @update-modal-view="onUpdateModalView"
    />

    <p
      v-if="SEASON_MODAL_VIEW_CONFIG[modalView].contentTitleKey"
      :class="{ topOffset: modalView === SeasonModalView.start }"
      class="contentTitle"
    >
      {{ $t(SEASON_MODAL_VIEW_CONFIG[modalView].contentTitleKey || '') }}
    </p>

    <div
      v-if="modalView === SeasonModalView.burnTokens"
      :class="{ 'new-year': store.isNewYearTheme }"
      class="sm:pb-0 tw:pb-4"
    >
      <UIModalInnerContentWrapper
        :style="
          $device.isMobile ? { padding: 0, border: 'none', background: 'none', height: '100%', maxHeight: '100%' } : {}
        "
      >
        <el-skeleton :loading="isLoadingSeasonPoints" animated>
          <template #template>
            <div class="tw:p-4 burnCardsContainer">
              <el-skeleton-item v-for="i in 5" :key="i" style="width: 100%; height: 184px" />
            </div>
          </template>
          <template #default>
            <div class="tw:p-4 burnCardsContainer">
              <SeasonBurnCard
                v-for="token of tokens"
                :key="`${token?.tokenAddress}-${token?.tokenId}`"
                :season-id="BigNumber(currentSeasonId!).toNumber()"
                :season-token="token"
                :token-id="BigNumber(token?.tokenId || 0).toNumber()"
                :token-value="BigNumber(token?.tokenValue || 0).toNumber()"
              />
            </div>
          </template>
        </el-skeleton>
      </UIModalInnerContentWrapper>
    </div>

    <div v-else-if="modalView === SeasonModalView.leaderboard" class="leaderboardBlock">
      <div class="leaderboardWrapper">
        <SeasonLeaderboardList
          :checked-historical-season="
            activeIndexLeaderboard ? BigNumber(activeIndexLeaderboard).minus(1).toNumber() : undefined
          "
          :is-jackpot="false"
        />
      </div>

      <div class="seasonSwitcherWrapper">
        <UIBuildingButton
          :class="{
            'slide-disabled': activeIndexLeaderboard === 1
          }"
          :disabled="
            isMobile ? swiperInstanceLeaderboard?.activeIndex === 1 : swiperInstanceLeaderboard?.activeIndex === 6
          "
          class="slide-prev"
          icon="singleArrowLeft"
          mode="compact"
          @handle-click="handlePrevLeaderboard"
        />

        <div class="seasonSwitcherItemsContainer">
          <div
            style="
              height: 20%;
              background: #1e353e;
              width: 98%;
              position: absolute;
              top: 50%;
              left: 10px;
              z-index: -1;
              transform: translateY(-50%);
            "
          >
            <div
              :style="{
                width: `${seasonsProgressMobileIndicatorLeaderboard}%`
              }"
              style="
                height: 100%;
                background: linear-gradient(
                  to right,
                  rgba(96, 255, 124, 1) 0%,
                  rgba(96, 255, 124, 1) 90%,
                  rgba(96, 255, 124, 0) 100%
                );
                max-width: 100%;
              "
            ></div>
          </div>

          <swiper
            :centered-slides="true"
            :height="90"
            :initial-slide="BigNumber(seasonsCount!).minus(1).toNumber()"
            :slides-per-view="$device.isMobile ? MOBILE_SLIDES_COUNT : DESKTOP_SLIDES_COUNT"
            :space-between="0"
            class="seasonSwitcherMobileSwiper"
            @swiper="
              (swiper) => {
                swiperInstanceLeaderboard = swiper;
                activeIndexLeaderboard = swiper.activeIndex + 1;
              }
            "
            @slide-change="
              (swiper) => {
                activeIndexLeaderboard = swiper.activeIndex + 1;
                updateProgressLeaderboard();
              }
            "
          >
            <swiper-slide v-for="i in seasonsCount" :key="i">
              <div
                :class="{
                  goldColor: BigNumber(i).isLessThanOrEqualTo(BigNumber(seasonsCount!)),
                  checkedSeason: activeIndexLeaderboard === i
                }"
                :style="{ fontSize: locale !== 'ru' ? '24px' : '16px' }"
                class="seasonSwitcherBtn"
                @click="
                  () => {
                    if (BigNumber(seasonsCount!).isLessThan(i)) return;
                    activeIndexLeaderboard = i;
                  }
                "
              >
                <span :style="{ transform: locale !== 'ru' ? 'translateY(-3px)' : 'translateY(0)' }">{{ i }}</span>
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <UIBuildingButton
          :class="{
            'slide-disabled': activeIndexLeaderboard && BigNumber(seasonsCount!).isEqualTo(activeIndexLeaderboard)
          }"
          :disabled="
            !!swiperInstanceLeaderboard?.activeIndex &&
            BigNumber(seasonsCount!).minus(1).isEqualTo(swiperInstanceLeaderboard.activeIndex)
          "
          class="slide-next"
          icon="singleArrowRight"
          mode="compact"
          @handle-click="handleNextLeaderboard"
        />
      </div>
    </div>

    <div v-else-if="modalView === SeasonModalView.jackpot" class="jackpotBlock">
      <el-dialog
        v-model="isShowHistoricalLeaderboard"
        :append-to-body="false"
        :center="true"
        :fullscreen="$device.isMobile"
        :title="$t(`seasonName37`)"
        class="historicalLeaderboardModal"
        @closed="activeIndex = null"
      >
        <ElIconArrowLeft
          :style="{ opacity: isPrevDisabled ? 0.5 : 1 }"
          style="position: absolute; cursor: pointer; height: 78px; top: 50%; left: -100px"
          @click="handlePrev"
        />
        <ElIconArrowRight
          :style="{ opacity: isNextDisabled ? 0.5 : 1 }"
          style="position: absolute; cursor: pointer; height: 78px; top: 50%; right: -100px"
          @click="handleNext"
        />

        <p class="seasonDuration">
          {{ $t('seasonHolding') }}: {{ checkedHistoricalSeasonStartDate }} - {{ checkedHistoricalSeasonEndDate }}
        </p>
        <SeasonLeaderboardList
          :checked-historical-season="
            BigNumber(activeIndex || 0)
              .minus(1)
              .toNumber()
          "
          :is-jackpot="true"
          style="padding-top: 10px"
        />
      </el-dialog>

      <div class="jackpotWrapper">
        <SeasonJackpot />
      </div>

      <div class="seasonSwitcherWrapper">
        <UIBuildingButton
          :disabled="swiperInstance?.activeIndex === 0"
          mode="compact"
          icon="singleArrowLeft"
          class="slide-prev"
          :class="{
            'slide-disabled': swiperInstance?.activeIndex === 0
          }"
          @handle-click="
            () => {
              if (swiperInstance?.activeIndex === 0) return;
              swiperInstance?.slideTo(0);
              selectedJackpotYear = 2025;
            }
          "
        />

        <div class="seasonSwitcherItemsContainer">
          <div
            style="
              height: 20%;
              background: #1e353e;
              width: 98%;
              position: absolute;
              top: 50%;
              left: 10px;
              z-index: -1;
              transform: translateY(-50%);
            "
          >
            <div
              style="
                height: 100%;
                background: linear-gradient(
                  to right,
                  rgba(96, 255, 124, 1) 0%,
                  rgba(96, 255, 124, 1) 90%,
                  rgba(96, 255, 124, 0) 100%
                );
                max-width: 100%;
              "
              :style="{
                width: `${seasonsProgressMobileIndicator}%`
              }"
            ></div>
          </div>

          <swiper
            :slides-per-view="$device.isMobile ? MOBILE_SLIDES_COUNT : DESKTOP_SLIDES_COUNT"
            :initial-slide="0"
            :space-between="0"
            :height="90"
            :centered-slides="true"
            class="seasonSwitcherMobileSwiper"
            @swiper="(swiper) => (swiperInstance = swiper)"
            @slide-change="
              (swiper) => {
                const year = swiper.activeIndex === 0 ? 2025 : 2026;
                selectedJackpotYear = year;
              }
            "
          >
            <swiper-slide :key="2025">
              <div
                class="seasonSwitcherBtn"
                :class="{
                  goldColor: true,
                  checkedSeason: selectedJackpotYear === 2025
                }"
                :style="{ fontSize: locale !== 'ru' ? '24px' : '16px' }"
                @click="
                  () => {
                    selectedJackpotYear = 2025;
                    swiperInstance?.slideTo(0);
                  }
                "
              >
                <span :style="{ transform: locale !== 'ru' ? 'translateY(-3px)' : 'translateY(0)' }">2025</span>
              </div>
            </swiper-slide>
            <swiper-slide :key="2026">
              <div
                class="seasonSwitcherBtn"
                :class="{
                  goldColor: true,
                  checkedSeason: selectedJackpotYear === 2026
                }"
                :style="{ fontSize: locale !== 'ru' ? '24px' : '16px' }"
                @click="
                  () => {
                    selectedJackpotYear = 2026;
                    swiperInstance?.slideTo(1);
                  }
                "
              >
                <span :style="{ transform: locale !== 'ru' ? 'translateY(-3px)' : 'translateY(0)' }">2026</span>
              </div>
            </swiper-slide>
          </swiper>
        </div>

        <UIBuildingButton
          mode="compact"
          icon="singleArrowRight"
          class="slide-next"
          :disabled="swiperInstance?.activeIndex === 1"
          :class="{
            'slide-disabled': swiperInstance?.activeIndex === 1
          }"
          @handle-click="
            () => {
              if (swiperInstance?.activeIndex === 1) return;
              swiperInstance?.slideTo(1);
              selectedJackpotYear = 2026;
            }
          "
        />
      </div>
    </div>

    <div v-else-if="modalView === SeasonModalView.start" class="startWrapper">
      <SeasonStart @update-modal-view="onUpdateModalView" />
    </div>

    <template v-else-if="modalView === SeasonModalView.endedInfo">
      <SeasonEndedInfo @update-modal-view="onUpdateModalView" />
    </template>

    <div v-else-if="modalView === SeasonModalView.end || modalView === SeasonModalView.rewards" class="endWrapper">
      <SeasonEnd
        @close="
          () => {
            emit('close');
            checkedSeason = BigNumber(currentSeasonId!).minus(1).toNumber();
          }
        "
        @update-modal-view="onUpdateModalView"
        @update-checked-season="
          (value: number) => {
            checkedSeason = value;
          }
        "
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import 'swiper/css';
import { useWeb3ModalAccount } from '@web3modal/ethers/vue';
import { BigNumber } from 'bignumber.js';
import { formatEther, formatUnits, ZeroAddress } from 'ethers';
import {
  BuildingsRegistry__factory,
  Erc20Token__factory,
  ERC721__factory,
  Multicall__factory,
  Rewards__factory,
  RewardsFactory__factory,
  Season__factory
} from 'public/abi/evm/types';
import type { Swiper as SwiperType } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import type { IRewards } from '~/public/abi/evm/types/Rewards';
import type { TNullable } from '~/types/common';
import { SeasonModalView, type TSeasonConfig, type TSeasonConfigItem, type TSeasonData } from '~/types/season';
import { SEASON_MODAL_VIEW_CONFIG } from '~/utils/constants';
import { infoModal, infoModalJackpot } from '~/utils/constants/infoModal';
import 'swiper/css/effect-coverflow';
import { Formatters } from '~/utils/formatters/formatters';

// const config = useRuntimeConfig();
// const isProdEnv = computed(() => config?.public.env === 'prod');
const { isMobile } = useDevice();

const { blockchain } = useEnvs();
const { getInterfaceDecoded, getMulticallResult } = useAbiAccess();
const { getProvider, getSigner } = useProvider();
const { sendContractMethod } = useSendContractMethod();
const { address } = useWeb3ModalAccount();
const { t, locale } = useI18n();
const store = useMainStore();
const { notificationUpdateVersion } = toRefs(store);
const swiperInstance = ref<SwiperType>();
const swiperInstanceLeaderboard = ref<SwiperType>();

const cache = new RuntimeCache();

const activeIndex = ref<TNullable<number>>(null);
const activeIndexLeaderboard = ref<TNullable<number>>(null);
const isShowHistoricalLeaderboard = ref(false);
const leaderboardHistoricalSeasonsData = ref<any[][]>([]);
const seasonsProgressMobileIndicatorLeaderboard = ref(0);

const seasonStartClicked = useCookie(`seasonStartClicked:${address.value}`, { default: () => false });
const props = defineProps<{ view?: TNullable<SeasonModalView> }>();

const emit = defineEmits<{
  close: [];
  updateModalHeader: [value: string];
}>();

const seasonContract = Season__factory.connect(blockchain.contracts.season, getProvider());
const seasonContractInterface = Season__factory.createInterface();
const multicallContract = Multicall__factory.connect(blockchain.multicallAddress, getProvider());

const currentSeasonId = inject<Ref<number>>('currentSeasonId');
const seasonsCount = inject<Ref<number>>('seasonsCount');
// const rawCurrentSeasonYear = await seasonContract.currentSeasonYear();
const selectedJackpotYear = ref<number>(2026);
const currentSeasonYear = computed(() => {
  // Для 2025: вычитаем 1 (rawCurrentSeasonYear - 1)
  // Для 2026: используем rawCurrentSeasonYear без вычитания
  return selectedJackpotYear.value === 2025 ? 1 : 2;
});

const calldata = Array(Number(seasonsCount?.value) - 1)
  .fill(null)
  .map((item, index) => [
    blockchain.contracts.season,
    seasonContractInterface.encodeFunctionData('getUserScoresBySeason', [index + 1, ZeroAddress, 1000])
  ]);

const updateLeaderboardHistoricalSeasonsData = async () => {
  if (!multicallContract) return;

  const calls = calldata.filter(Boolean); // ensure no null calls
  const chunks = chunkArray(calls, 40);

  const results = await Promise.all(
    chunks.map(async (chunk) => {
      const res = await multicallContract.tryAggregate.staticCall(
        true,
        chunk.map((item) => ({
          target: item[0],
          callData: item[1]
        }))
      );
      return res.map((item: any) => seasonContractInterface.decodeFunctionResult('getUserScoresBySeason', item[1]));
    })
  );

  leaderboardHistoricalSeasonsData.value = results.flat();
};
await updateLeaderboardHistoricalSeasonsData();

provide('leaderboardHistoricalSeasonsData', leaderboardHistoricalSeasonsData);

provide('currentSeasonYear', currentSeasonYear);
provide('selectedJackpotYear', selectedJackpotYear);

const checkedSeason = ref(BigNumber(currentSeasonId!.value).minus(1).toNumber());

const { data } = useNuxtData<TSeasonConfig>('seasonsConfig');

const seasonsProgressMobileIndicator = ref(0);

const MOBILE_SLIDES_COUNT = 3;
const DESKTOP_SLIDES_COUNT = 13;

const getSeasonData = (): TSeasonData | null => {
  const swiper = swiperInstance.value;
  if (!swiper) return null;

  return {
    selectedSeasonIndex: swiper.realIndex || swiper.activeIndex || 0,
    currentSeason: BigNumber(currentSeasonId!.value).toNumber(),
    maxSlides: isMobile ? MOBILE_SLIDES_COUNT : DESKTOP_SLIDES_COUNT
  };
};

const calculateProgressForCurrentSeason = (seasonData: TSeasonData) => {
  const targetSeason = isMobile ? seasonData.currentSeason : seasonData.currentSeason - 1.5;
  const targetSeasonPositionInView = targetSeason - seasonData.selectedSeasonIndex;
  const progressInView = (targetSeasonPositionInView / seasonData.maxSlides) * 100;
  const baseProgress = (seasonData.selectedSeasonIndex / blockchain.seasonsCountInCurrentYear) * 100;

  return Math.min(baseProgress + progressInView, 100);
};

const calculateProgressForVisibleSeason = (seasonData: TSeasonData) => {
  const targetSeason = isMobile ? seasonData.currentSeason : seasonData.currentSeason - 1.5;
  const targetSeasonPositionInView = targetSeason - seasonData.selectedSeasonIndex;
  const progressInView = (targetSeasonPositionInView / seasonData.maxSlides) * 100;
  const baseProgress = (seasonData.selectedSeasonIndex / blockchain.seasonsCountInCurrentYear) * 100;

  return Math.min(baseProgress + progressInView, 100);
};

const updateProgress = () => {
  const seasonData = getSeasonData();
  if (!seasonData) return;

  const { selectedSeasonIndex, currentSeason, maxSlides } = seasonData;
  const isSelectedSeasonPassed = selectedSeasonIndex < currentSeason;
  const isSelectedSeasonCurrent = selectedSeasonIndex === currentSeason;

  if (isSelectedSeasonCurrent) {
    seasonsProgressMobileIndicator.value = calculateProgressForCurrentSeason(seasonData);
  } else if (selectedSeasonIndex - maxSlides < currentSeason && selectedSeasonIndex + maxSlides > currentSeason) {
    seasonsProgressMobileIndicator.value = calculateProgressForVisibleSeason(seasonData);
  } else if (isSelectedSeasonPassed) {
    seasonsProgressMobileIndicator.value = 100;
  } else {
    seasonsProgressMobileIndicator.value = 0;
  }
};

const handlePrev = () => {
  if (isPrevDisabled.value) return;

  if (isShowHistoricalLeaderboard.value && activeIndex.value) {
    activeIndex.value -= 1;
    swiperInstance.value?.slideTo(activeIndex.value - 1);
  } else {
    swiperInstance.value?.slidePrev();
  }
};

const handleNext = () => {
  if (isNextDisabled.value) return;

  if (isShowHistoricalLeaderboard.value && activeIndex.value) {
    activeIndex.value += 1;
    swiperInstance.value?.slideTo(activeIndex.value - 1);
  } else {
    swiperInstance.value?.slideNext();
  }
};

const getSeasonDataLeaderboard = (): TSeasonData | null => {
  const swiper = swiperInstanceLeaderboard.value;
  if (!swiper) return null;

  return {
    selectedSeasonIndex: swiper.realIndex || swiper.activeIndex || 0,
    currentSeason: BigNumber(currentSeasonId!.value).toNumber(),
    maxSlides: isMobile ? MOBILE_SLIDES_COUNT : DESKTOP_SLIDES_COUNT
  };
};

const updateProgressLeaderboard = () => {
  const seasonData = getSeasonDataLeaderboard();
  if (!seasonData) return;

  const { selectedSeasonIndex, currentSeason, maxSlides } = seasonData;
  const isSelectedSeasonPassed = selectedSeasonIndex < currentSeason;
  const isSelectedSeasonCurrent = selectedSeasonIndex === currentSeason;

  if (isSelectedSeasonCurrent) {
    seasonsProgressMobileIndicatorLeaderboard.value = calculateProgressForCurrentSeason(seasonData);
  } else if (selectedSeasonIndex - maxSlides < currentSeason && selectedSeasonIndex + maxSlides > currentSeason) {
    seasonsProgressMobileIndicatorLeaderboard.value = calculateProgressForVisibleSeason(seasonData);
  } else if (isSelectedSeasonPassed) {
    seasonsProgressMobileIndicatorLeaderboard.value = 100;
  } else {
    seasonsProgressMobileIndicatorLeaderboard.value = 0;
  }
};

const handlePrevLeaderboard = () => {
  if (isPrevDisabledLeaderboard.value) return;

  if (activeIndexLeaderboard.value) {
    activeIndexLeaderboard.value -= 1;
    swiperInstanceLeaderboard.value?.slideTo(activeIndexLeaderboard.value - 1);
  } else {
    swiperInstanceLeaderboard.value?.slidePrev();
  }
};

const handleNextLeaderboard = () => {
  if (isNextDisabledLeaderboard.value) return;

  if (activeIndexLeaderboard.value) {
    activeIndexLeaderboard.value = (activeIndexLeaderboard.value || 0) + 1;
    swiperInstanceLeaderboard.value?.slideTo(activeIndexLeaderboard.value - 1);
  } else {
    swiperInstanceLeaderboard.value?.slideNext();
  }
};

// Watch for swiper changes
watchImmediate(() => swiperInstance.value?.activeIndex, updateProgress);
watchImmediate(() => swiperInstanceLeaderboard.value?.activeIndex, updateProgressLeaderboard);

watchImmediate(notificationUpdateVersion, updateLeaderboardHistoricalSeasonsData);

const seasonEndDate = inject<ComputedRef<Date>>('seasonEndDate');
const showSeasonModal = inject<ComputedRef<boolean>>('showSeasonModal');
const ended = inject<Ref<boolean, boolean>>('ended');
const timeLeft = inject<{
  seconds: number;
  minutes: number;
  hours: number;
  days: number;
  months: number;
  isInit: boolean;
  ended: boolean;
}>('timeLeft');

const prevSeasonId = computed(() => BigNumber(currentSeasonId!.value).minus(1).toNumber());

const isPrevDisabled = computed(() => {
  if (isShowHistoricalLeaderboard.value) {
    return activeIndex.value === 1;
  }
  return swiperInstance.value?.isBeginning ?? false;
});

const isNextDisabled = computed(() => {
  if (isShowHistoricalLeaderboard.value) {
    return activeIndex.value === (seasonsCount!.value ?? 0);
  }
  return swiperInstance.value?.isEnd ?? false;
});

const isPrevDisabledLeaderboard = computed(() => {
  if (activeIndexLeaderboard.value) {
    return activeIndexLeaderboard.value === 1;
  }
  return swiperInstanceLeaderboard.value?.isBeginning ?? false;
});

const isNextDisabledLeaderboard = computed(() => {
  if (activeIndexLeaderboard.value) {
    return activeIndexLeaderboard.value === (seasonsCount!.value ?? 0);
  }
  return swiperInstanceLeaderboard.value?.isEnd ?? false;
});

const didParticipateInPreviousSeason = computed(() => {
  if (!address.value || !leaderboardHistoricalSeasonsData?.value) {
    return false;
  }

  const prevId = prevSeasonId.value;
  if (!prevId || prevId <= 0) return false;

  const previousSeasonIndex = prevId - 1; // 0-based: season 1 -> index 0

  if (
    !Array.isArray(leaderboardHistoricalSeasonsData.value) ||
    previousSeasonIndex < 0 ||
    previousSeasonIndex >= leaderboardHistoricalSeasonsData.value.length
  ) {
    return false;
  }

  const previousSeasonData = leaderboardHistoricalSeasonsData.value[previousSeasonIndex];

  if (!previousSeasonData || !previousSeasonData[0] || previousSeasonData[0].length === 0) {
    return false;
  }

  return previousSeasonData[0].some((item: any[]) => item[0]?.toLowerCase() === address.value?.toLowerCase());
});

async function getFormattedSeasonDate(seasonId: number | undefined, fallbackDate?: Date | string) {
  if (seasonId === undefined) return '';
  const timestamp = await seasonContract.getSeasonStartAt(seasonId);
  if (!timestamp) return fallbackDate ? useDateFormat(() => fallbackDate, 'DD.MM') : '';
  const ms = BigNumber(timestamp.toString()).multipliedBy(1000).toNumber();
  return useDateFormat(() => new Date(ms), 'DD.MM');
}

const prevSeasonStartDate = asyncComputed(() => getFormattedSeasonDate(prevSeasonId!.value));

const prevSeasonEndDate = asyncComputed(() => getFormattedSeasonDate(currentSeasonId!.value));

const checkedHistoricalSeasonStartDate = asyncComputed(() =>
  getFormattedSeasonDate(
    BigNumber(activeIndex.value || 0)
      .minus(1)
      .toNumber()
  )
);

const checkedHistoricalSeasonEndDate = asyncComputed(async () => {
  const previousIndex = BigNumber(activeIndex.value || 0).minus(1);
  if (previousIndex.isGreaterThanOrEqualTo(currentSeasonId!.value)) {
    return useDateFormat(() => seasonEndDate?.value, 'DD.MM');
  }
  return getFormattedSeasonDate(BigNumber(activeIndex.value || 0).toNumber());
});

const initialModalView = computed(() => {
  if (props.view) {
    return props.view;
  }
  if (seasonStartClicked.value) {
    return SeasonModalView.burnTokens;
  } else if (didParticipateInPreviousSeason.value) {
    return SeasonModalView.endedInfo;
  } else {
    return SeasonModalView.start;
  }
});
const tokens = ref<TSeasonConfigItem[]>([]);
const modalView = ref(props.view || initialModalView.value);
const showInfoPopup = ref(false);

interface JackpotReward {
  token: string;
  amount: bigint;
  isNFT: boolean;
}

interface JackpotPositionRewards {
  position: number;
  rewards: JackpotReward[];
}

interface JackpotRewardUI {
  token: string;
  isNFT: boolean;

  amountRaw: bigint;
  amount: string;
}

interface JackpotPositionRewardsUI {
  position: number;
  rewards: JackpotRewardUI[];
}

const normalizeJackpotRewards = (
  raw: IRewards.PositionRewardsStructOutput[][],
  fromPosition: number
): JackpotPositionRewards[] => {
  return raw.map((positionRewards, index) => ({
    position: fromPosition + index,
    rewards: positionRewards.map(([token, amount, isNFT]) => ({
      token,
      amount,
      isNFT
    }))
  }));
};

const DEFAULT_ERC20_DECIMALS = 18;

const mapJackpotRewardsToUI = (
  data: JackpotPositionRewards[],
  decimalsMap?: Record<string, number>
): JackpotPositionRewardsUI[] => {
  return data.map((position) => ({
    position: position.position,
    rewards: position.rewards.map((reward) => {
      const decimals = decimalsMap?.[reward.token.toLowerCase()] ?? DEFAULT_ERC20_DECIMALS;

      return {
        token: reward.token,
        isNFT: reward.isNFT,

        amountRaw: reward.amount,
        amount: formatUnits(reward.amount, decimals)
      };
    })
  }));
};

const jackpotRewardsData = ref();
const jackpotCanBeClaimed = ref(false);
const jackpotIsClaimed = ref(false);
const isLoadingJackpotRewards = ref(false);

const canShowJackpotClaimButton = computed(() => jackpotCanBeClaimed.value && !jackpotIsClaimed.value);

onMounted(async () => {
  isLoadingJackpotRewards.value = true;
  try {
    const json = await fetchUserRewards();
    jackpotRewardsData.value = json;
    await checkJackpotClaimStatus();
  } finally {
    isLoadingJackpotRewards.value = false;
  }
});

const fetchUserRewards = async (year?: number) => {
  const targetYear = year ?? selectedJackpotYear.value;
  const seasonYear = targetYear === 2025 ? 1 : 2;

  try {
    const rewardContractAddress = await cache.run(
      `listOfRewards-${seasonYear}`,
      async () => {
        const rewardFactoryContract = RewardsFactory__factory.connect(
          blockchain.contracts.rewardsFactory,
          getProvider()
        );

        return rewardFactoryContract.getCloneContract(seasonYear);
      },
      CacheTime.Hour
    );

    const rewardContract = Rewards__factory.connect(rewardContractAddress, getProvider());

    const maxPosition = targetYear === 2026 ? 100 : 30;
    const raw = await rewardContract.getJackpotRewards(1, maxPosition);

    const domain = normalizeJackpotRewards(raw, 1);

    return mapJackpotRewardsToUI(domain);
  } catch (error) {
    console.error('Error fetching jackpot rewards:', error);
    // Возвращаем пустой массив вместо null/undefined, чтобы состояние загрузки сбросилось
    return [];
  }
};

const checkJackpotClaimStatus = async () => {
  if (!address.value) {
    console.log('Address is not available');
    return;
  }

  const seasonYear = selectedJackpotYear.value === 2025 ? 1 : 2;

  const rewardContractAddress = await cache.run(
    `listOfRewards-${seasonYear}`,
    async () => {
      const rewardFactoryContract = RewardsFactory__factory.connect(blockchain.contracts.rewardsFactory, getProvider());

      return rewardFactoryContract.getCloneContract(seasonYear);
    },
    CacheTime.Hour
  );

  const rewardContract = Rewards__factory.connect(rewardContractAddress, getProvider());
  const maxPosition = selectedJackpotYear.value === 2026 ? 100 : 30;
  const userPosition = await seasonContract.getUserPositionInYear(seasonYear, address.value, maxPosition);

  if (userPosition === BigInt(0)) return;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [rewards, position] = await rewardContract.getUserJackpotPositionRewards(address.value);

  const positionNumber = Number(position);

  console.log('zzz positionNumber ', positionNumber);

  if (!position || positionNumber <= 0) {
    console.log('User has no jackpot position or position is invalid');
    return;
  }

  const canBeClaimed = await rewardContract.jackpotCanBeClaimed(positionNumber);
  const isClaimed = await rewardContract.isJackpotPositionClaimed(positionNumber);

  console.log('zzz jackpotCanBeClaimed:', canBeClaimed);
  console.log('zzz isJackpotPositionClaimed:', isClaimed);

  jackpotCanBeClaimed.value = canBeClaimed;
  jackpotIsClaimed.value = isClaimed;
};

const claimJackpotRewards = async () => {
  console.log('[claimJackpotRewards] Method started');

  if (!address.value) {
    console.log('[claimJackpotRewards] Address is not available');
    return false;
  }

  console.log('[claimJackpotRewards] Address:', address.value);

  const seasonYear = selectedJackpotYear.value === 2025 ? 1 : 2;
  console.log('[claimJackpotRewards] Season year:', seasonYear);

  console.log('[claimJackpotRewards] Getting reward contract address...');
  const rewardContractAddress = await cache.run(
    `listOfRewards-${seasonYear}`,
    async () => {
      console.log('[claimJackpotRewards] Fetching contract address from factory...');
      const rewardFactoryContract = RewardsFactory__factory.connect(blockchain.contracts.rewardsFactory, getProvider());

      return rewardFactoryContract.getCloneContract(seasonYear);
    },
    CacheTime.Hour
  );
  console.log('[claimJackpotRewards] Reward contract address:', rewardContractAddress);

  console.log('[claimJackpotRewards] Getting signer...');
  const signer = await getSigner();
  console.log('[claimJackpotRewards] Signer obtained');

  console.log('[claimJackpotRewards] Connecting to contract with signer...');
  const writeContract = Rewards__factory.connect(rewardContractAddress, signer);
  console.log('[claimJackpotRewards] Contract connected');

  console.log('[claimJackpotRewards] Sending transaction...');
  const transaction = await sendContractMethod({
    contract: writeContract,
    methodName: 'claimJackpotRewards',
    args: []
  }).catch((error) => {
    console.error('[claimJackpotRewards] Error sending transaction:', error);
    return null;
  });

  if (!transaction) {
    console.log('[claimJackpotRewards] Transaction failed or was cancelled');
    return false;
  }

  console.log('[claimJackpotRewards] Transaction sent, hash:', transaction.hash);
  saveHashToLocalStorage(`${t('jackpotTransactionClaim')}`, transaction.hash);
  store.updateVersion();

  console.log('[claimJackpotRewards] Waiting for transaction confirmation (2 blocks)...');
  await transaction.wait(2);
  console.log('[claimJackpotRewards] Transaction confirmed');

  modifyHistoryHashStatus(transaction.hash, 'Done');
  store.updateVersion();
  console.log('[claimJackpotRewards] Transaction status updated to Done');

  console.log('[claimJackpotRewards] Updating claim status...');
  await checkJackpotClaimStatus();
  console.log('[claimJackpotRewards] Claim status updated');

  console.log('[claimJackpotRewards] Method completed successfully');
  return true;
};

const isLoadingSeasonPoints = ref(false);
watchImmediate(
  [address, () => data.value?.config?.length, () => store.buyPackCounter, notificationUpdateVersion],
  async (newDataLength) => {
    if (!data.value || !newDataLength) return;

    const erc20 = data.value.config.filter(
      (token: TSeasonConfigItem) => tokenMetaData(blockchain.contracts, token.tokenAddress)?.interface === 'erc20'
    );

    const erc721 = data.value.config.filter(
      (token: TSeasonConfigItem) => tokenMetaData(blockchain.contracts, token.tokenAddress)?.interface === 'erc721'
    );

    try {
      isLoadingSeasonPoints.value = true;
      const erc20SeasonPoints = await getErc20SeasonPoints(erc20);
      const erc721SeasonPoints = await getErc721SeasonPonts(erc721);
      const mc = Multicall__factory.connect(blockchain.multicallAddress, getProvider());

      const filteredNfts = erc721SeasonPoints.filter((data: any) => data.tokenId !== undefined);
      const erc721TokensRentResult = await mc.tryAggregate.staticCall(
        true,
        filteredNfts.map((data: any) => ({
          target: blockchain.contracts.buildingsRegistry,
          callData: BuildingsRegistry__factory.createInterface().encodeFunctionData(
            'isBuildingRegistered(address,uint256)',
            [data.tokenAddress, data.tokenId.toString()]
          )
        }))
      );

      const resultingNfts = filteredNfts.filter((item: any, index: any) => {
        return erc721TokensRentResult[index][1].slice(-1) !== '1';
      });

      const mergedTokens = [...erc20SeasonPoints, ...resultingNfts];

      tokens.value = mergedTokens.sort((a, b) =>
        b.seasonPoints !== a.seasonPoints ? b.seasonPoints - a.seasonPoints : b.rate - a.rate
      );
    } finally {
      isLoadingSeasonPoints.value = false;
    }
  }
);

watch(
  () => ended?.value,
  (newValue) => {
    if (newValue) modalView.value = SeasonModalView.end;
  },
  { immediate: true }
);

watch(
  () => props.view,
  (newView) => {
    if (newView) {
      modalView.value = newView;
    }
  },
  { immediate: true }
);

watch(
  [() => showSeasonModal?.value, () => ended?.value],
  ([newShow, newEnded]) => {
    if (!newShow && !newEnded && seasonStartClicked.value) {
      modalView.value = SeasonModalView.burnTokens;
    } else if (newEnded) {
      modalView.value = SeasonModalView.end;
    }
  },
  { immediate: true }
);

watch(
  initialModalView,
  (newVal) => {
    if (!props.view) {
      modalView.value = newVal;
    }
  },
  { immediate: true }
);

watch([currentSeasonId, leaderboardHistoricalSeasonsData], ([newSeasonId], [oldSeasonId]) => {
  const diff = BigNumber(String(newSeasonId || 0)).minus(String(oldSeasonId || 0));
  if (!diff.isEqualTo(1)) return;

  if (didParticipateInPreviousSeason.value) {
    modalView.value = SeasonModalView.endedInfo;
  } else {
    modalView.value = SeasonModalView.start;
  }
});

watch(
  [modalView, checkedSeason, locale],
  ([newView]) => {
    switch (newView) {
      case SeasonModalView.burnTokens:
      case SeasonModalView.start:
      case SeasonModalView.leaderboard:
      case SeasonModalView.end:
        emit('updateModalHeader', t(`seasonName37`));
        break;
      case SeasonModalView.rewards:
        emit('updateModalHeader', `${t('coreRewardStatus')}: ${t(`seasonName37`)}`);
        break;
      case SeasonModalView.jackpot:
        emit('updateModalHeader', t(`jackpot`));
        break;
      case SeasonModalView.endedInfo:
        emit('updateModalHeader', t(`seasonEndedInfoTitle`));
        break;
      default:
        break;
    }
  },
  { immediate: true }
);

watch(selectedJackpotYear, async () => {
  if (modalView.value === SeasonModalView.jackpot) {
    isLoadingJackpotRewards.value = true;
    jackpotRewardsData.value = null; // Очищаем старые данные перед загрузкой новых
    try {
      const json = await fetchUserRewards();
      jackpotRewardsData.value = json;
      await checkJackpotClaimStatus();
    } finally {
      isLoadingJackpotRewards.value = false;
    }
  }
});

provide('modalView', modalView);
provide('prevSeasonId', prevSeasonId);
provide('jackpotRewardsData', jackpotRewardsData);
provide('isLoadingJackpotRewards', isLoadingJackpotRewards);
provide('canShowJackpotClaimButton', canShowJackpotClaimButton);
provide('claimJackpotRewards', claimJackpotRewards);

const onUpdateModalView = (view: SeasonModalView) => {
  modalView.value = view;
};

async function getErc20SeasonPoints(erc20: TSeasonConfigItem[]) {
  const erc20Addresses = erc20.map((token) => token.tokenAddress);
  const multicallResult = await getMulticallResult(
    Erc20Token__factory.createInterface(),
    erc20Addresses,
    'balanceOf',
    true
  );

  return erc20Addresses
    .map((_, index: number) => {
      const balance = Array.isArray(multicallResult) ? formatEther(BigInt(multicallResult[index][1])) : '0';
      const bigNumberBalance = BigNumber(Math.floor(Number(balance)));

      const seasonPoints = bigNumberBalance
        .minus(bigNumberBalance.toNumber() % erc20[index].tokenMultiplier)
        .dividedBy(erc20[index].tokenMultiplier || 1)
        .multipliedBy(erc20[index].pointsMultiplier)
        .integerValue(BigNumber.ROUND_FLOOR)
        .decimalPlaces(2)
        .toNumber();

      return {
        ...erc20[index],
        balance,
        seasonPoints,
        rate: erc20[index].pointsMultiplier
      };
    })
    .flat();
}

async function getErc721SeasonPonts(erc721: TSeasonConfigItem[]) {
  const erc721Interface = ERC721__factory.createInterface();
  const erc721Addresses = erc721.map((token) => token.tokenAddress);
  const multicallContractSigned = Multicall__factory.connect(blockchain.multicallAddress, getProvider());

  let multicallResult = await getMulticallResult(
    ERC721__factory.createInterface(),
    erc721Addresses,
    'getTokenIds',
    true
  );

  const erc721Ids: number[][] = multicallResult.map((elem: any) => getInterfaceDecoded(elem[1]));
  const tokenAddresses: any = erc721Ids
    .map((tokenIdsArray: any[], tokenIndex: number) => {
      return tokenIdsArray[0].map((tokenId: any) => [
        erc721[tokenIndex].tokenAddress,
        erc721Interface.encodeFunctionData('getTokenValue', [tokenId])
      ]);
    })
    .flat();
  multicallResult = await multicallContractSigned?.tryAggregate.staticCall(true, tokenAddresses);

  const erc721HashMap = Object.fromEntries(erc721.map((item) => [item.tokenAddress, item]));
  const erc721Contacts = Array.isArray(multicallResult)
    ? tokenAddresses.map((tokenAddress: any[], index: number) => {
        const tokenId = erc721Interface.decodeFunctionData('getTokenValue', tokenAddress[1])[0];
        const tokenValue = Number(multicallResult[index][1]);
        const { pointsMultiplier } = erc721HashMap[tokenAddress[0]];
        const seasonPoints = BigNumber(pointsMultiplier).multipliedBy(tokenValue).toString();

        return { ...erc721HashMap[tokenAddress[0]], seasonPoints, tokenId, tokenValue, rate: seasonPoints };
      })
    : [];
  const zeroBalanceErc721Contracts = erc721
    .filter(
      (token) => !tokenAddresses?.length || !tokenAddresses.map((item: any) => item[0]).includes(token.tokenAddress)
    )
    .map((token) => ({
      ...token,
      seasonPoints: 0,
      rate: 0
    }));

  return erc721Contacts.concat(zeroBalanceErc721Contracts).flat();
}
</script>

<style lang="scss" scoped>
.top-gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 300px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.6) 0%, transparent 100%);
  pointer-events: none;
  z-index: -1;
}

.container {
  width: 100%;
  font-family: Grenze, sans-serif;

  &.fix-height {
    height: 680px !important;
  }

  @media screen and (max-width: 767px) {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .infoIcon {
    position: absolute;
    top: 21px;
    cursor: pointer;
  }

  .seasonDuration,
  .seasonDescription,
  .contentTitle {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
  }

  .seasonDescription {
    margin: 0 32px;
  }

  .topOffset {
    margin-top: 40px;
  }

  .contentTitle {
    color: #fff;
    font-size: 24px;
    margin-bottom: 1rem;

    @media screen and (max-width: 479px) {
      margin-top: 20px;
      margin-bottom: 8px;
    }
  }

  .seasonDuration {
    color: #88e1ff;
    font-family: Eczar, sans-serif;
  }

  .seasonDescription {
    color: rgba(255, 255, 255, 0.8);
    width: 80%;
    margin: 0 auto;
  }

  .jackpotWrapper {
    display: flex;
    width: 100%;
    align-items: stretch;
    gap: 20px;
    margin-top: 20px;

    @media screen and (max-width: 560px) {
      flex-direction: column;
      gap: 0;
      width: 100%;
      max-height: calc(100dvh - 230px);
      margin-top: 0;
      margin-left: 0;
      margin-right: 0;
      padding: 0;
    }
  }

  .seasonSwitcherWrapper {
    width: 100%;
    isolation: isolate;
    position: relative;

    z-index: 9999;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: 560px) {
      max-width: 100%;
    }
  }

  .seasonSwitcherItemsContainer {
    overflow: auto;
    scrollbar-width: none;
    width: 100%;
    padding: 8px;
  }

  .seasonSwitcherItems {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media screen and (max-width: 560px) {
      gap: 20px;
      padding: 8px 0;
    }
  }

  .seasonSwitcherBtn {
    width: 43px;
    font-size: 30px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: center;
    line-height: 1;
    font-family: Grenze, sans-serif;
    border-radius: 50%;
    cursor: pointer;
    background: linear-gradient(to top, #070c0e 0%, #1d4350 100%);
    color: rgba(255, 255, 255, 0.3);
    aspect-ratio: 1/1;
    pointer-events: none;
  }

  .goldColor {
    color: #eea92e;
    border: solid 1px rgba(134, 121, 39, 1);
    pointer-events: all;

    @media (hover: hover) {
      &:hover {
        color: rgba(255, 255, 255, 1);

        &::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          background-image: radial-gradient(circle at 50% 100%, rgba(0, 131, 173, 1), rgba(0, 0, 0, 0) 50%);
          border-radius: 50%;
          z-index: 0;
        }
      }
    }
  }

  .checkedSeason {
    box-shadow: 0px 0px 8px #eea92e;
    background: linear-gradient(to bottom, #0199ae 0%, #002537 100%);
    transform: scale(1.1);
  }

  .burnCardsContainer {
    display: grid;
    gap: 25px;
    width: 100%;
    grid-template-columns: repeat(5, minmax(0, 1fr));

    @media screen and (max-width: 767px) {
      display: flex;
      flex-direction: column;
    }
  }

  .endWrapper {
    @media screen and (max-width: 767px) {
      height: 100%;
    }
  }

  .leaderboardWrapper {
    @media screen and (max-width: 767px) {
      max-width: 100vw;
    }
  }

  .leaderboardBlock {
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;

    .leaderboardWrapper {
      flex: 1;
      min-height: 0;
      overflow: hidden;
      padding-bottom: 90px; // Отступ для пагинации
    }

    .seasonSwitcherWrapper {
      position: absolute;
      bottom: 60px;
      left: 0;
      right: 0;
      flex-shrink: 0;
    }
  }

  .jackpotBlock {
    width: 100%;
  }
}
</style>

<style lang="scss">
.jackpotBlock {
  .el-overlay {
    background-color: rgba(0, 0, 0, 0.85);
  }

  width: 100%;
}

.el-dialog.seasonModal,
.el-dialog.historicalLeaderboardModal {
  overflow: visible;
  margin: 0;
  position: fixed;
  left: 50%;
  width: 100%;
}

.el-dialog.historicalLeaderboardModal {
  max-width: 70%;
  top: 5%;
  transform: translateX(-50%);
  height: calc(95% - 65px);

  @media screen and (max-width: 560px) {
    top: 0;
    height: calc(100dvh - 50px);
    max-width: 100%;
  }
}

.el-dialog.seasonModal {
  max-width: 905px;
  min-height: 447px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-position: 0 0;
  background-size: cover;
  background-repeat: no-repeat;

  h &:after {
    content: '';
    display: block;
    z-index: -1;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(8, 27, 37, 0.4);
  }

  &.new-year {
    background-image: url('~/public/img/newYear/bg-2.png');
  }

  &.minHeight {
    min-height: 60%;

    @media screen and (max-width: 560px) {
      max-height: 100dvh;
    }
  }

  .el-dialog__title {
    color: #fff;
    padding-right: 0;
  }

  .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 10px;
    height: 100%;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 100%;

    @media screen and (max-width: 767px) {
      max-height: 93%;
    }

    .contentTitle {
      color: #fff;
    }
  }

  .modalSeasonInfo {
    overflow: hidden;
    z-index: 99999 !important;
  }
}

.el-dialog.seasonModal.minContentWidth {
  background-image: none;
}

.el-dialog.seasonModal.seasonModalMobile.rewards {
  .el-dialog__body {
    @media screen and (max-width: 767px) {
      max-height: unset;
    }
  }
}

.el-dialog.seasonModal.ru-locale {
  @media screen and (max-width: 479px) {
    .seasonModalSwitcherContainer {
      min-height: 55px;
    }
  }
}

.seasonSwitcherMobileSwiper {
  &.swiper {
    padding: 8px 0;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
  }
}
</style>
